import { ContextAction } from '../types';
import type { CoBrandDetailsAction, CoBrandDetailsState } from './types';

export const coBrandDetailsInitial: CoBrandDetailsState = {
  name: '',
  logo: '',
  smallLogo: '',
  lang: '',
  subDomain: '',
  clientId: '',
  themeName: 'primary',
  carousal: [],
  isLoaded: false,
  excludedAncillarySources: []
};

export const coBrandDetailsReducer = (
  state: CoBrandDetailsState = coBrandDetailsInitial,
  action: CoBrandDetailsAction
): CoBrandDetailsState => {
  switch (action.type) {
    case ContextAction.setCoBrandDetails:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
